import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const EditDetailsButton = ({
    isLocked,
    entering,
    open_details_section,
    openEditDetailsFromDocumentDetail,
    allActions,
}) => {
    return (
        <OverlayTrigger
            placement='top'
            onEntering={entering}
            overlay={
                <Tooltip
                    id='tooltip'
                    style={{
                        backgroundColor: 'rgb(0, 35, 58)',
                        color: 'white',
                        marginBottom: '20px',
                    }}
                >
                    <div
                        style={{
                            backgroundColor: 'rgb(0, 35, 58)',
                            color: 'white',
                        }}
                    >
                        {/* 10098: Update name from Details to Edit Details */}
                        Edit Details
                    </div>
                </Tooltip>
            }
        >
            <div
                className={
                    open_details_section
                        ? 'icon_fun outer-col active'
                        : 'icon_fun outer-col'
                }
                style={{
                    display: 'inline-block',
                }}
                // 10098: Directly call edit_details instead of intermediary step
                onClick={() =>
                    isLocked ? null : openEditDetailsFromDocumentDetail()
                }
            >
                <span
                    className={open_details_section ? 'active' : null}
                    style={{
                        cursor: isLocked === true ? 'not-allowed' : 'pointer',
                    }}
                >
                    <i
                        className={
                            allActions.hasOwnProperty('details') &&
                            allActions.details.icon !== null
                                ? allActions.details.icon
                                : 'fa-solid fa-notes-medical'
                        }
                        style={{
                            color:
                                allActions.hasOwnProperty('details') &&
                                allActions.details.color !== null
                                    ? allActions.details.color
                                    : '',
                        }}
                    />
                </span>
            </div>
        </OverlayTrigger>
    );
};

export default EditDetailsButton;
